import React from 'react';
import MissionDetail from './MissionDetail';
import missionsData from '../data/missions.json';

function MissionSkillsDevelopment() {
  return <MissionDetail mission={missionsData.skillsDevelopment} />;
}

export default MissionSkillsDevelopment;
